<template>
  <div class="ChallengeCreate">
    <div class="nav">
      <el-button round icon="el-icon-arrow-left" @click="onViewAll">View All</el-button>
    </div>
    <div class="main">
      <p class="title">{{cid===''?'Create':'Edit'}} Challenge</p>
      <div class="body">
        <el-form ref="form" :rules="rules" :model="form" label-width="110px" label-position="left" size="medium">
          <div style="display: flex;flex-direction: column;align-items: center">
            <div class="form">
              <div class="left">
                <el-form-item label="Title" prop="title_en">
                  <el-col :span="15">
                    <el-input maxlength="30" placeholder="Challenge Title (EN)" show-word-limit
                              v-model="form.title_en"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="Title" prop="title_cn">
                  <el-col :span="15">
                    <el-input maxlength="30" placeholder="Challenge Title (CN)" show-word-limit
                              v-model="form.title_cn"></el-input>
                  </el-col>
                </el-form-item>

                <el-form-item label="Info" prop="info_en">
                  <el-input type="textarea" :rows="2" placeholder="Challenge Info (EN)"
                            v-model="form.info_en"></el-input>
                </el-form-item>
                <el-form-item label="Info" prop="info_cn">
                  <el-input type="textarea" :rows="2" placeholder="Challenge Info (CN)"
                            v-model="form.info_cn"></el-input>
                </el-form-item>

                <el-form-item label="Location">
                  <el-col :span="15">
                    <el-input maxlength="30" placeholder="Challenge Location (EN)" show-word-limit
                              v-model="form.location_en"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="Location">
                  <el-col :span="15">
                    <el-input maxlength="30" placeholder="Challenge Location (CN)" show-word-limit
                              v-model="form.location_cn"></el-input>
                  </el-col>
                </el-form-item>

                <div style="display: flex;align-items: center">
                  <el-form-item label="Duration" prop="date_range">
                    <el-date-picker
                        v-model="form.date_range"
                        type="daterange"
                        start-placeholder="Start Date"
                        end-placeholder="End Date"
                        style="width: 100%"
                        :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                  </el-form-item>
                </div>

                <div class="row" style="display: flex;justify-content: space-between">
                  <el-form-item label="Step Count" label-width="100px" prop="steps" style="flex-shrink: 0;width: 50%;">
                    <el-col :span="20">
                      <el-input v-model.number="form.steps" placeholder="Total Steps"></el-input>
                    </el-col>
                  </el-form-item>
                </div>

                <div class="row" style="display: flex;">
                  <el-form-item label="Daily Minimum Step" label-width="150" prop="eminsteps" style="flex-shrink: 0;width: 50%;">
                    <el-col :span="10">
                      <el-input v-model.number="form.eminsteps" placeholder="Each Day Minimum Step Count"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="Daily Maximum Step" label-width="150" prop="esteps" style="flex-shrink: 0;width: 50%;">
                    <el-col :span="10">
                      <el-input v-model.number="form.esteps" placeholder="Each Day Maximum Step Count"></el-input>
                    </el-col>
                  </el-form-item>
                </div>

                <div class="row" style="display: flex;">
                  <el-form-item label="Viewed number" label-width="120px" prop="viewed_count" style="flex-shrink: 0;width: 50%;">
                    <el-col :span="20">
                      <el-input v-model.number="form.viewed_count" placeholder="view number"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="Joined number" label-width="120px" prop="joined_count" style="flex-shrink: 0;width: 50%;">
                    <el-col :span="20">
                      <el-input v-model.number="form.joined_count" placeholder="Joined number"></el-input>
                    </el-col>
                  </el-form-item>
                </div>

                <el-form-item label="Set as Top">
                  <el-switch v-model="form.top"></el-switch>
                </el-form-item>
              </div>

              <div class="right">
                <div class="upload">
                  <p><span style="color: #F56C6C">*</span> Upload Thumbnail Image (Up to 1)</p>
                  <ImageUpload :limit="1" style="max-width: 150px;overflow: hidden" target="thumbnail"
                               :input="cid!==''?form.thumbnail_images:[]"
                               @output="onUpdateImage"></ImageUpload>
                </div>
                <div class="upload">
                  <p><span style="color: #F56C6C">*</span> Upload Poster Image (Up to 1)</p>
                  <ImageUpload :limit="1" style="max-width: 150px;overflow: hidden" target="poster"
                               :input="cid!==''?form.poster_images:[]"
                               @output="onUpdateImage"></ImageUpload>
                </div>
                <div class="upload">
                  <p><span style="color: #F56C6C">*</span> Upload Banner Images (Up to 9)</p>
                  <ImageUpload :limit="9" target="banner" @output="onUpdateImage"
                               :input="cid!==''?form.banner_images:[]"></ImageUpload>
                </div>
              </div>

              <!-- Zocoin price -->
              <div style="position: absolute; right: 0;top: 0;    width: 530px;height: 50px;color: #000;"> 
                <el-form-item label="Price For Zocoins" label-width="150px" prop="price_zocoins" style="flex-shrink: 0;">
                    <el-col :span="10">
                      <el-input v-model.number="form.price_zocoins" placeholder="Price For Zocoins"></el-input>
                    </el-col>
                  </el-form-item>
              </div>

              <!-- Product Brand -->
              <div style="position: absolute; right: 0;top: 50px;    width: 530px;height: 50px;color: #000;"> 
                <el-form-item label="For Brand" label-width="150px" prop="brand_id" style="flex-shrink: 0;">
                    <el-col :span="10">
                      <el-select size="small" v-model="form.brand_id" style="width: 160px;float: right" filterable
                                placeholder="Select Brand">
                        <el-option
                            v-for="item in brand_list"
                            :key="item.brand_id"
                            :label="item.brand_name_en"
                            :value="item.brand_id">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>
              </div>

              <!-- Prize Section -->
              <div class="prize">
                <el-form-item label="Enable Prize">
                  <el-switch v-model="form.prize_enable"></el-switch>
                </el-form-item>
                <el-form-item label="Prize Count" :prop="form.prize_enable?'prize_count':''">
                  <el-col :span="10">
                    <el-input v-model.number="form.prize_count" placeholder="Quantity of Prizes"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="Discount" :prop="form.prize_enable?'prize_name_en':''">
                  <el-col :span="15">
                    <el-input maxlength="30" show-word-limit placeholder="Name (EN)"
                              v-model="form.prize_name_en"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="Discount" :prop="form.prize_enable?'prize_name_cn':''">
                  <el-col :span="15">
                    <el-input maxlength="30" show-word-limit placeholder="Name (CN)"
                              v-model="form.prize_name_cn"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="Prize Detail" :prop="form.prize_enable?'prize_detail_en':''">
                  <el-input type="textarea" :rows="2" placeholder="Detail (EN)"
                            v-model="form.prize_detail_en"></el-input>
                </el-form-item>
                <el-form-item label="Prize Detail" :prop="form.prize_enable?'prize_detail_cn':''">
                  <el-input type="textarea" :rows="2" placeholder="Detail (CN)"
                            v-model="form.prize_detail_cn"></el-input>
                </el-form-item>
                <el-form-item label="Claim Period" :prop="form.prize_enable?'prize_claim_period':''">
                  <el-date-picker
                      v-model="form.prize_claim_period"
                      type="daterange"
                      start-placeholder="Start Date"
                      end-placeholder="End Date"
                      style="width: 100%"
                      :default-time="['00:00:00', '23:59:59']">
                  </el-date-picker>
                </el-form-item>
                <div class="upload">
                  <p v-if="form.prize_enable"><span style="color: #F56C6C">*</span> Upload Prize Image (Up to 1)</p>
                  <p v-else>Upload Prize Image (Up to 1)</p>
                  <ImageUpload :limit="1" style="max-width: 150px;overflow: hidden" target="prize"
                               :input="cid!==''?form.prize_images:[]"
                               @output="onUpdateImage"></ImageUpload>
                </div>
              </div>

            </div>
            <el-form-item class="button">
              <el-button
                  style="width: 150px;height: 40px;font-size: 16px;border-radius: 30px;box-shadow: 0 0 6px #a1a1a1"
                  :type="submit_enable?'primary':'info'" @click="submit_enable?onSubmitForm('form'):''">
                {{cid!==''?'Save':'Create'}}
              </el-button>
            </el-form-item>
          </div>
        </el-form>


      </div>

    </div>
  </div>
</template>

<script>
  import ImageUpload from '@/components/Images/Images'
  import {challengeSave, getChallengeDetail, getBrandList} from "@/utils/api";

  export default {
    components: {
      ImageUpload
    },
    watch: {
      form: {
        handler(val) {
          let submit_enable = false;
          let check_list = [];
          if (val.prize_enable) {
            check_list = [
              val.title_en.length >= 5,
              val.title_cn.length >= 5,
              val.info_en.length >= 10,
              val.info_cn.length >= 10,
              val.date_range!==null&&val.date_range.length === 2,
              val.steps > 0 && !isNaN(val.steps),
              !isNaN(val.esteps),
              !isNaN(val.eminsteps),
              val.thumbnail_images.length !== 0,
              val.poster_images.length !== 0,
              val.banner_images.length !== 0,

              val.prize_count !== 0 && !isNaN(val.prize_count),
              val.prize_name_en.length >= 1,
              val.prize_name_cn.length >= 1,
              val.prize_detail_en.length >= 1,
              val.prize_detail_cn.length >= 1,
              val.prize_claim_period!==null&&val.prize_claim_period[0]!==''&&val.prize_claim_period[1]!=='',
              val.prize_images.length !==0
            ];
          } else {
            check_list = [
              val.title_en.length >= 5,
              val.title_cn.length >= 5,
              val.info_en.length >= 10,
              val.info_cn.length >= 10,
              val.date_range!==null&&val.date_range.length === 2,
              val.steps > 0 && !isNaN(val.steps),
              !isNaN(val.esteps),
              !isNaN(val.eminsteps),
              val.thumbnail_images.length !== 0,
              val.poster_images.length !== 0,
              val.banner_images.length !== 0,
            ];
          }

          for (let i = 0; i < check_list.length; i++) {
            let check = check_list[i];
            if (!check) {
              this.submit_enable = false;
              return
            }
            submit_enable = true
          }
          this.submit_enable = submit_enable
        },
        deep: true
      }
    },
    props: ['cid'],
    data: () => {
      return {
        brand_list: [],
        submit_enable: false,
        form: {
          id: '',
          title_en: '',
          title_cn: '',
          info_en: '',
          info_cn: '',
          location_en: '',
          location_cn: '',
          date_range: '',
          steps: '',
          esteps: 0,
          eminsteps: 0,
          top: false,
          thumbnail_images: [],
          poster_images: [],
          banner_images: [],
          joined_count: 0,
          viewed_count: 0,
          price_zocoins: 0,
          brand_id: null,
          prize_enable: false,
          prize_count: 0,
          prize_name_en: '',
          prize_name_cn: '',
          prize_detail_en: '',
          prize_detail_cn: '',
          prize_claim_period: ['', ''],
          prize_images: []
        },
        rules: {
          title_en: [
            {required: true, message: 'Title (EN) is required', trigger: 'blur'},
            {min: 5, max: 30, message: 'At least 5 characters', trigger: 'blur'}
          ],
          title_cn: [
            {required: true, message: 'Title (CN) is required', trigger: 'blur'},
            {min: 5, max: 30, message: 'At least 5 characters', trigger: 'blur'}
          ],
          info_en: [
            {required: true, message: 'Info (EN) is required', trigger: 'blur'},
            {min: 10, message: 'At least 10 characters', trigger: 'blur'}
          ],
          info_cn: [
            {required: true, message: 'Info (CN) is required', trigger: 'blur'},
            {min: 10, message: 'At least 10 characters', trigger: 'blur'}
          ],
          date_range: [
            {required: true, message: 'Duration is required', trigger: 'blur'}
          ],
          steps: [
            {required: true, message: 'Step count is required', trigger: 'blur'},
            {type: 'number', message: 'Must be a number'}
          ],
          viewed_count: [
            {type: 'number', message: 'Must be a number'}
          ],
          price_zocoins: [
            {type: 'number', message: 'Must be a number'}
          ],
          joined_count: [
            {type: 'number', message: 'Must be a number'}
          ],
          prize_count: [
            {required: true, message: 'Prize count is required', trigger: 'blur'},
            {type: 'number', message: 'Must be a number'}
          ],
          prize_name_en: [
            {required: true, message: 'Prize name (EN) is required', trigger: 'blur'},
            {min: 1, max: 30, message: 'At least 1 characters', trigger: 'blur'}
          ],
          prize_name_cn: [
            {required: true, message: 'Prize name (CN) is required', trigger: 'blur'},
            {min: 1, max: 30, message: 'At least 1 characters', trigger: 'blur'}
          ],
          prize_detail_en: [
            {required: true, message: 'Prize detail (EN) is required', trigger: 'blur'},
            {min: 1, max: 30, message: 'At least 1 characters', trigger: 'blur'}
          ],
          prize_detail_cn: [
            {required: true, message: 'Prize detail (CN) is required', trigger: 'blur'},
            {min: 1, max: 30, message: 'At least 1 characters', trigger: 'blur'}
          ],
          prize_claim_period: [
            {required: true, message: 'Claim period is required', trigger: 'blur'}
          ],
        }
      }
    },
    beforeMount() {
      if (this.cid !== '') {
        getChallengeDetail(this.cid).then(res => {
          let d = res.detail;
          this.form = {
            id: d.challenge_id,
            title_en: d.challenge_title_en,
            title_cn: d.challenge_title_cn,
            info_en: d.challenge_info_en,
            info_cn: d.challenge_info_cn,
            location_en: d.challenge_location_en,
            location_cn: d.challenge_location_cn,
            date_range: [d.challenge_start, d.challenge_end],
            steps: d.challenge_step_count,
            esteps: d.challenge_each_day_maximum_step,
            eminsteps: d.challenge_each_day_minimum_step,
            top: d.challenge_top_state,
            thumbnail_images: [d.thumbnail_image],
            poster_images: [d.poster_image],
            banner_images: d.banner_images,
            joined_count: d.joined_count,
            viewed_count: d.viewed_count,
            brand_id: d.brand_bid,
            price_zocoins: d.price_zocoins,
            prize_enable: d.challenge_prize_enable,
            prize_count: d.challenge_prize_count,
            prize_name_en: d.challenge_prize_text_en,
            prize_name_cn: d.challenge_prize_text_cn,
            prize_detail_en: d.challenge_prize_detail_en,
            prize_detail_cn: d.challenge_prize_detail_cn,
            prize_claim_period: [d.challenge_prize_start !== null ? d.challenge_prize_start : '', d.challenge_prize_end !== null ? d.challenge_prize_end : ''],
            prize_images: [d.prize_image]
          }
        })
        getBrandList().then(res => {
          if (res.errcode === 0) {
            res.brand_list.unshift({
              brand_id: null,
              brand_name_en: '#UnBrand'
            });
            this.brand_list = res.brand_list
          } else {
            this.$message.error('Error in getting brands')
          }
        });
      }
    },
    methods: {
      onUpdateImage(e) {
        if (e.target === 'banner') {
          this.form.banner_images = e.image_list
        } else if (e.target === 'prize') {
          this.form.prize_images = e.image_list
        } else if (e.target === 'poster') {
          this.form.poster_images = e.image_list
        } else if (e.target === 'thumbnail') {
          this.form.thumbnail_images = e.image_list
        }
      },
      onViewAll() {
        this.$emit('switch', {
          target: 'home'
        })
      },
      onSubmitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit_enable = true;
            this.$showLoading('Processing');
            challengeSave(this.form).then(res => {
              this.$hideLoading();
              if (res.errcode === 0) {
                this.submit_enable = false;
                this.$message.success('Challenge Saved!');
                setTimeout(() => {
                  this.$emit('switch', {
                    target: 'home'
                  })
                }, 500)
              }
            })
          } else {
            this.submit_enable = false;
            this.$message.warning('Check your inputs for any empty fields')
          }
        });
      },
    }
  };
</script>

<style lang="scss" scoped>
  @import "_ChallengeCreate.scss";
</style>